import React, { Component } from 'react';

import { themes } from 'kb-shared';
import styled from 'styled-components';

type Props = {
  progress: number;
};
type State = {};

export default class ProgressBar extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container>
        <Background>
          <Fill $progress={this.props.progress} />
        </Background>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 22px;
  width: 100%;
`;

const Background = styled.div`
  background-color: ${themes.colors.white};
  height: 100%;
  border-radius: 11px;
  margin: 0px 24px 0px 0;
  box-shadow: ${themes.shadows.card.level1};
`;

interface FillProps {
  $progress: number;
}

const Fill = styled.div<FillProps>`
  background-color: ${themes.colors.neutral.primaryNavy};
  height: 100%;
  width: ${({ $progress }) => ($progress * 100).toString() + '%'};
  border-radius: 11px;
`;
